
import CountDown from "./count-down";
import OrderLines from "./order-lines";
import SlideBalls from "./slide-balls";
import "./index.scss";
import React from "react";

const ToyControl = (props) => {
  const {
      socketServiceInstanct,
      linkId,
      qrCode,
      fromCam,
      isEnd,
      toysData,
      linkInfo,
      toyStatus,
      endSocket,
      setIsEnd,
      userOnline
  } = props;

  return (
    <>
      <div id="pc-toy-control" className="pc-toy-control">
        <div className="pc-order-line">
          <OrderLines toyStatus={toyStatus} userOnline={userOnline}></OrderLines>
        </div>
        <SlideBalls
          linkId={linkId}
          isEnd={isEnd}
          socketServiceInstanct={socketServiceInstanct}
          toysData={toysData}>
        </SlideBalls>
        <CountDown 
          isEnd={isEnd}
          linkId={linkId}
          toysData={toysData}
          linkInfo={linkInfo}
          qrCode={qrCode}
          fromCam={fromCam}
          socketServiceInstanct={socketServiceInstanct}
          setIsEnd={setIsEnd}
          endSocket={endSocket}/>
      </div>
    </>
  )
}

export default ToyControl